import React from 'react';
import Routes from './Routes';
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { IntlProvider } from 'react-intl';
import translationFr from './utils/translation.fr.json';
import useTranslationQuery from './graphql/queries/change-language';

const App = () => {
    const { data } = useTranslationQuery();

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <IntlProvider  locale="en" messages={data && data.language.language === "FR" ? translationFr: ''}>
                <Routes />
            </IntlProvider>            
        </MuiPickersUtilsProvider>
    )
}

export default App;
